import { formatPercent } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'superScoreGrade' })
export class SuperScoreGradePipe implements PipeTransform {
  transform(score: number) {
    if (score == null) {
      return '';
    }
    if (score < -0.4) {
      return 'F';
    }
    if (score < -0.2) {
      return 'D';
    }
    if (score < 0) {
      return 'C';
    }
    if (score < 0.2) {
      return 'B';
    }
    if (score >= 0.2) {
      return 'A';
    }
  }
}

@Pipe({ name: 'positivePercent' })
export class PositivePercentPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private readonly locale: string) {}
  transform(percent: number) {
    if (percent == null) {
      return null;
    }
    return (
      (percent > 0 ? '+' : '') + formatPercent(percent, this.locale, '1.1-1')
    );
  }
}
